import { render, staticRenderFns } from "./ArrowUpload.vue?vue&type=template&id=08965ba4&"
import script from "./ArrowUpload.vue?vue&type=script&lang=ts&"
export * from "./ArrowUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports